// @flow

// import createPickingLineQuantitiesTableColumn from './components/table/PickingLineQuantitiesTableColumn';

export const components = {
    // 'tableColumn:pickingLineQuantities': createPickingLineQuantitiesTableColumn,
}
